// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1UelC","infoBtn":"quickbooks_infoBtn__2skS0","formBox":"quickbooks_formBox__1nZdM","formFooter":"quickbooks_formFooter__3cPzI"};